export default {
  name: 'NaviBar',
  components: {},
  data () {
    return {
      logoMain: this.$store.state.imgPath + 'logoPSAIncheon.png',
      logoGlobal: this.$store.state.imgPath + 'logoPSAglobal.png'
    }
  },
  methods: {
    changeKorean () {
      this.$i18n.locale = 'ko'
    },
    changeEnglish () {
      this.$i18n.locale = 'en'
    }
  }
}
